<!-- 
    Here is where the component card is defined based on configuration and templates 
-->
<section #maincontent role='main'>
    <mat-card >
        @if( !isLoggedIn && !isVertical) {
        <mat-card-header>
            <mat-card-title-group class="flex-col">
                <img mat-card-md-image [ngClass]="['application-image']" [src]='imageUrl' alt="">
                <section class="mutara-title">
                    <h1 class="mat-headline-1">{{appTitle}}</h1>
                    <h2 class="mat-headline-3"><markdown>
                        {{appConfig?.info.preamble 
                    ?? "Let us help you setup your goals for future success. Our schools and degree programs have different requirements and we can help you identify the best fit for your education."}}
                    </markdown></h2>
                </section>
            </mat-card-title-group>
        </mat-card-header>
        }
    </mat-card>

    @if (!isLoggedIn && !!isVertical) {
    <mat-expansion-panel [class]="['mutara-expansion-panel', 'mat-elevation-z']">
        <mat-expansion-panel-header class="mutara-expansion-panel-header">
            <mat-panel-title>
                <h1 class="mat-headline-1">{{appTitle}}</h1>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-expansion-panel-content class="mutara-expansion-panel-content" markdown>
            {{appConfig.info.preamble ?? "Let us help you setup your goals for future success. Our schools and degree programs have different requirements and we can help you identify the best fit for your education."}}
        </mat-expansion-panel-content>
    </mat-expansion-panel>
    }

    <!-- 4.0 Account Registration -->
    @if (!isLoggedIn && !hasRegistration ) {
    <account-settings [isSearchOpen]="skipHelp"></account-settings>
    }
    @if (!!isLoggedIn || !!hasRegistration) {
    <!-- Action header and  extra text -->
    <mat-card class="display-flex">
        <mat-card-header>
            @if( !!actionDefinition ) {
            <mat-card-title>
                <h2 class="mat-headline-3">{{actionDefinition?.title}}</h2>
                @if (selected ) {
                <mutara-selected></mutara-selected>
                }
            </mat-card-title>
            }
        </mat-card-header>

        <mat-card-content>
            @if ( !!actionDefinition?.content ) {
            <div>{{actionDefinition.content.label | substitution:this}}
                @if (!!actionDefinition?.content.help ) {
                <a aria-label="" [href]="actionDefinition.content.help.link"
                    [target]="actionDefinition.content.help?.target ?? '_self'">
                    {{actionDefinition.content.help.label}}
                    @if (!!actionDefinition?.content?.help?.icon) {
                    <mat-icon class="mutara-icon">{{actionDefinition.content.help.icon}}</mat-icon>
                    }
                </a>
                }
                <mat-divider class="mutara-divider"></mat-divider>
            </div>
            }
            <form #mainform (ngSubmit)='persistData()'>
                @if ((stepDefinitions?.length ?? 0) > 0) {
                <mutara-stepper [parentLayout]="layout" [layout]="this" [stepDefinitions]="stepDefinitions" [isFixed]="true"
                    [canMove]="!currentLayout?.linear" [selected]="selected"></mutara-stepper>
                }
            </form>
        </mat-card-content>

        @if (!!actionDefinition?.buttons) {
        <mat-card-actions align='end'>
            @for( button of actionDefinition?.buttons;track button.label; let index = $index;) {
            @if ( !['link'].includes(button.type)) {
            <button mat-flat-button (click)="$clickedButton(index)" color="primary" [type]="button.type">
                @if (!!button?.icon ) {
                <mat-icon>{{button.icon}}</mat-icon>
                }
                {{button.label | substitution:this}}
            </button>
            } @else {
            <a [href]="button.action">{{button.label | substitution:this}}
                @if (!!button?.icon ) {
                <mat-icon>{{button.icon}}</mat-icon>
                }
            </a>
            }
            }
        </mat-card-actions>
        }
        @if ( !!actionDefinition?.footer ) {
        <mat-card-footer [ngClass]="['mutara-subtitle','mutara-lr-pad']">{{actionDefinition?.footer |
            substitution:this}}</mat-card-footer>
        }
    </mat-card>
    }
</section>